"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SupplementIcn(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "supplement-icn",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    "class": "icon-bg",
    fill: "#FFF",
    cx: "258",
    cy: "259",
    r: "242"
  }), _react["default"].createElement("path", {
    d: "M355.559 304h-52.5v52.5c0 23.47-19.03 42.5-42.5 42.5s-42.5-19.03-42.5-42.5V304h-52.5c-23.47 0-42.5-19.03-42.5-42.5 0-11.74 4.76-22.36 12.45-30.05 7.69-7.69 18.31-12.45 30.05-12.45h52.5v-52.5c0-23.47 19.03-42.5 42.5-42.5 11.74 0 22.36 4.76 30.05 12.45 7.69 7.69 12.45 18.31 12.45 30.05V219h52.5c23.47 0 42.5 19.03 42.5 42.5s-19.03 42.5-42.5 42.5z",
    "class": "icon-fill",
    fill: "#2CD5C4"
  }), _react["default"].createElement("path", {
    d: "M384.059 261.5c0-15.738-12.762-28.5-28.5-28.5h-66.5v-66.5c0-7.674-3.028-14.829-8.35-20.15-5.322-5.322-12.477-8.35-20.15-8.35-15.738 0-28.5 12.762-28.5 28.5V233h-66.5c-7.674 0-14.83 3.028-20.15 8.35-5.323 5.321-8.35 12.476-8.35 20.15 0 15.738 12.762 28.5 28.5 28.5h66.5v66.5c0 15.738 12.762 28.5 28.5 28.5s28.5-12.762 28.5-28.5V290h66.5c15.738 0 28.5-12.762 28.5-28.5zM256.309-1c68.729 0 133.346 26.764 181.944 75.364 48.6 48.599 75.365 113.215 75.365 181.944 0 51.562-15.2 101.313-43.953 143.874-28.05 41.52-67.193 73.751-113.195 93.208-7.118 3.016-15.335-.316-18.348-7.439-3.012-7.121.319-15.336 7.44-18.349 85.08-35.985 140.056-118.923 140.056-211.294 0-61.251-23.853-118.835-67.163-162.145C375.144 50.852 317.56 27 256.309 27c-61.251 0-118.835 23.852-162.146 67.163C50.853 137.473 27 195.057 27 256.308c0 61.251 23.853 118.835 67.163 162.146 43.31 43.31 100.895 67.163 162.146 67.163 7.732 0 14 6.268 14 14s-6.268 14-14 14c-68.73 0-133.346-26.765-181.944-75.364C25.765 389.654-1 325.038-1 256.308c0-68.729 26.765-133.345 75.365-181.944C122.963 25.764 187.58-1 256.309-1zm4.25 111c15.177 0 29.43 6.03 39.95 16.55 10.519 10.52 16.55 24.772 16.55 39.95V205h38.5c31.202 0 56.5 25.298 56.5 56.5s-25.298 56.5-56.5 56.5h-38.5v38.5c0 31.202-25.298 56.5-56.5 56.5s-56.5-25.298-56.5-56.5V318h-38.5c-31.202 0-56.5-25.298-56.5-56.5 0-15.178 6.03-29.43 16.55-39.95 10.52-10.52 24.772-16.55 39.95-16.55h38.5v-38.5c0-31.202 25.298-56.5 56.5-56.5z",
    "class": "icon-outline",
    fill: "#1436B8",
    fillRule: "nonzero"
  }))));
}

SupplementIcn.defaultProps = {
  size: 30
};
var _default = SupplementIcn;
exports["default"] = _default;